// extracted by mini-css-extract-plugin
export default {"sun":"IconSun_sun__NauXx","dark":"IconSun_dark__irGRO","light":"IconSun_light__WEV09"};